import css from 'styled-jsx/css';

const staticStyles = css`
  .EditTemplateForm {
    :global(.ReduxSelectField) {
      max-width: 300px;
      width: 100%;
    }
    &__langHint {
      display: block;
      margin-top: 3px;
      margin-bottom: 30px;
      font-size: 13px;
      color: #999;
    }
    :global(.ReduxTextField) {
      width: 100%;
      margin-bottom: 10px;
    }
    :global(.TextAreaField) {
      width: 100%;
    }

    &__btns {
      :global(.DefaultButton) {
        margin-right: 30px;
      }
    }
  }
`;

export default staticStyles;
